export enum DatasetType {
    ERECEPT_PRESCRIPTIONS = "ERECEPT_PRESCRIPTIONS",
    ERECEPT_DISPENSES = "ERECEPT_DISPENSES",
    DISTRIBUTIONS_FROM_MAHS = "DISTRIBUTIONS_FROM_MAHS",
    DISTRIBUTIONS_FROM_DISTRIBUTORS = "DISTRIBUTIONS_FROM_DISTRIBUTORS",
    DISTRIBUTIONS_FROM_PHARMACIES = "DISTRIBUTIONS_FROM_PHARMACIES"
}

export const DISTRIBUTION_DATASETS: DatasetType[] = [
    DatasetType.DISTRIBUTIONS_FROM_MAHS,
    DatasetType.DISTRIBUTIONS_FROM_DISTRIBUTORS,
    DatasetType.DISTRIBUTIONS_FROM_PHARMACIES
]

export const ERECEPT_DATASETS: DatasetType[] = [
    DatasetType.ERECEPT_PRESCRIPTIONS,
    DatasetType.ERECEPT_DISPENSES
]
